import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./BannerSection.css";

export default function BannerSection(props) {
  const [currentDisplay, setCurrentDisplay] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    if (width < 768) setCurrentDisplay(`url(${props.bannerBGmobile})`);
    else setCurrentDisplay(`url(${props.bannerBG})`);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container
      style={{ backgroundImage: currentDisplay }}
      fluid
      className="banner-section"
    >
      <div
        style={{ background: props.fadeBG }}
        className="banner-section-overlay"
      >
        <Container>
          <Row>
            <Col className="banner-section-first-col">
              {" "}
              <h2
                style={{ color: props.white, fontSize: props.bannerTitleSize }}
              >
                {props.iconTitle} {props.bannerTitle}
              </h2>
              <p
                style={{
                  color: props.white,
                  fontSize: props.bannerSubTitleSize,
                }}
              >
                {props.bannerSubTitle}
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Container>
  );
}
